export default __webpack_public_path__ + "static/Galaxy-77b7ccfdc13add2a99eef62343bfaff4.png";